/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterPasswordRouteImport } from './routes/register-password'
import { Route as MfaRouteImport } from './routes/mfa'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AgreementsRouteImport } from './routes/agreements'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWithGlobalLayoutRouteImport } from './routes/_authenticated/_with-global-layout'
import { Route as AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRouteImport } from './routes/_authenticated/attachments/$inquiryMessageAttachmentUid/index'
import { Route as AuthenticatedWithGlobalLayoutTrialsIndexRouteImport } from './routes/_authenticated/_with-global-layout/trials/index'
import { Route as AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRouteImport } from './routes/_authenticated/_with-global-layout/trials/$trialNumber/index'

const RegisterPasswordRoute = RegisterPasswordRouteImport.update({
  id: '/register-password',
  path: '/register-password',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaRoute = MfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AgreementsRoute = AgreementsRouteImport.update({
  id: '/agreements',
  path: '/agreements',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWithGlobalLayoutRoute =
  AuthenticatedWithGlobalLayoutRouteImport.update({
    id: '/_with-global-layout',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute =
  AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRouteImport.update({
    id: '/attachments/$inquiryMessageAttachmentUid/',
    path: '/attachments/$inquiryMessageAttachmentUid/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedWithGlobalLayoutTrialsIndexRoute =
  AuthenticatedWithGlobalLayoutTrialsIndexRouteImport.update({
    id: '/trials/',
    path: '/trials/',
    getParentRoute: () => AuthenticatedWithGlobalLayoutRoute,
  } as any)
const AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute =
  AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRouteImport.update({
    id: '/trials/$trialNumber/',
    path: '/trials/$trialNumber/',
    getParentRoute: () => AuthenticatedWithGlobalLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agreements': typeof AgreementsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/mfa': typeof MfaRoute
  '/register-password': typeof RegisterPasswordRoute
  '/trials/': typeof AuthenticatedWithGlobalLayoutTrialsIndexRoute
  '/attachments/$inquiryMessageAttachmentUid/': typeof AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute
  '/trials/$trialNumber/': typeof AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/agreements': typeof AgreementsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/mfa': typeof MfaRoute
  '/register-password': typeof RegisterPasswordRoute
  '/trials': typeof AuthenticatedWithGlobalLayoutTrialsIndexRoute
  '/attachments/$inquiryMessageAttachmentUid': typeof AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute
  '/trials/$trialNumber': typeof AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/agreements': typeof AgreementsRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/mfa': typeof MfaRoute
  '/register-password': typeof RegisterPasswordRoute
  '/_authenticated/_with-global-layout': typeof AuthenticatedWithGlobalLayoutRouteWithChildren
  '/_authenticated/_with-global-layout/trials/': typeof AuthenticatedWithGlobalLayoutTrialsIndexRoute
  '/_authenticated/attachments/$inquiryMessageAttachmentUid/': typeof AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute
  '/_authenticated/_with-global-layout/trials/$trialNumber/': typeof AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agreements'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/mfa'
    | '/register-password'
    | '/trials/'
    | '/attachments/$inquiryMessageAttachmentUid/'
    | '/trials/$trialNumber/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/agreements'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/mfa'
    | '/register-password'
    | '/trials'
    | '/attachments/$inquiryMessageAttachmentUid'
    | '/trials/$trialNumber'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/agreements'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/mfa'
    | '/register-password'
    | '/_authenticated/_with-global-layout'
    | '/_authenticated/_with-global-layout/trials/'
    | '/_authenticated/attachments/$inquiryMessageAttachmentUid/'
    | '/_authenticated/_with-global-layout/trials/$trialNumber/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AgreementsRoute: typeof AgreementsRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  MfaRoute: typeof MfaRoute
  RegisterPasswordRoute: typeof RegisterPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register-password': {
      id: '/register-password'
      path: '/register-password'
      fullPath: '/register-password'
      preLoaderRoute: typeof RegisterPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa': {
      id: '/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof MfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agreements': {
      id: '/agreements'
      path: '/agreements'
      fullPath: '/agreements'
      preLoaderRoute: typeof AgreementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/_with-global-layout': {
      id: '/_authenticated/_with-global-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedWithGlobalLayoutRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/attachments/$inquiryMessageAttachmentUid/': {
      id: '/_authenticated/attachments/$inquiryMessageAttachmentUid/'
      path: '/attachments/$inquiryMessageAttachmentUid'
      fullPath: '/attachments/$inquiryMessageAttachmentUid/'
      preLoaderRoute: typeof AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/_with-global-layout/trials/': {
      id: '/_authenticated/_with-global-layout/trials/'
      path: '/trials'
      fullPath: '/trials/'
      preLoaderRoute: typeof AuthenticatedWithGlobalLayoutTrialsIndexRouteImport
      parentRoute: typeof AuthenticatedWithGlobalLayoutRoute
    }
    '/_authenticated/_with-global-layout/trials/$trialNumber/': {
      id: '/_authenticated/_with-global-layout/trials/$trialNumber/'
      path: '/trials/$trialNumber'
      fullPath: '/trials/$trialNumber/'
      preLoaderRoute: typeof AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRouteImport
      parentRoute: typeof AuthenticatedWithGlobalLayoutRoute
    }
  }
}

interface AuthenticatedWithGlobalLayoutRouteChildren {
  AuthenticatedWithGlobalLayoutTrialsIndexRoute: typeof AuthenticatedWithGlobalLayoutTrialsIndexRoute
  AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute: typeof AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute
}

const AuthenticatedWithGlobalLayoutRouteChildren: AuthenticatedWithGlobalLayoutRouteChildren =
  {
    AuthenticatedWithGlobalLayoutTrialsIndexRoute:
      AuthenticatedWithGlobalLayoutTrialsIndexRoute,
    AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute:
      AuthenticatedWithGlobalLayoutTrialsTrialNumberIndexRoute,
  }

const AuthenticatedWithGlobalLayoutRouteWithChildren =
  AuthenticatedWithGlobalLayoutRoute._addFileChildren(
    AuthenticatedWithGlobalLayoutRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedWithGlobalLayoutRoute: typeof AuthenticatedWithGlobalLayoutRouteWithChildren
  AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute: typeof AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedWithGlobalLayoutRoute:
    AuthenticatedWithGlobalLayoutRouteWithChildren,
  AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute:
    AuthenticatedAttachmentsInquiryMessageAttachmentUidIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AgreementsRoute: AgreementsRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  MfaRoute: MfaRoute,
  RegisterPasswordRoute: RegisterPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
